import { WebAppEnvironment } from '@buspro/web/core';

export const environment: WebAppEnvironment = {
  env: 'STAGING',
  production: true,
  api: 'https://staging-apis.buspro.biz/api',
  server: 'https://staging-apis.buspro.biz',
  // Where the tenant workspace lives. The website's Log In link and any
  // cross-app deep link read this instead of hardcoding a domain per env.
  tenantAppUrl: 'https://staging-apps.buspro.biz',
  s3: {
    accessKeyId: 'AKIA6QBENJSJQYNEIP6F',
    secretAccessKey: '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',
    region: 'eu-west-2',
    busproCompanyLogosBucket: 'buspro-company-logos',
  },
  publicWebsiteUrl: 'https://staging.buspro.biz',
  googleMapsApiKey: 'AIzaSyCuDWVccIOG7z2dZ7QMRQEqGSG6oSiH2wM',
  mdvr: {
    url: 'https://mdvr.buspro.biz',
    account: 'admin',
    password: 'Hagvan@2025c',
  },
  pusher: {
    appKey: 'fff74d82ef47ca6bca72',
    cluster: 'mt1',
  },
  qrCode: {
    parcelTrackingUrlPattern: 'https:\\/\\/staging\\.buspro\\.biz\\/track\\/[^/]+\\/item\\/([^/]+)',
    parcelTrackingBaseUrl: 'https://staging.buspro.biz/track',
  },
  features: {
    emailVerificationRequired: false, // Disabled for staging - testers can use fake emails
    strictPasswordValidation: false, // Disabled for staging - allow simple passwords
    accountLockoutEnabled: true, // Enabled - security testing
    twoFactorAuthAvailable: false, // Disabled - not yet fully implemented
  },
};
